import { render, staticRenderFns } from "./manualsmg5.vue?vue&type=template&id=21df2686&scoped=true&"
import script from "./manualsmg5.vue?vue&type=script&lang=js&"
export * from "./manualsmg5.vue?vue&type=script&lang=js&"
import style0 from "./manualsmg5.vue?vue&type=style&index=0&id=21df2686&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21df2686",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21df2686')) {
      api.createRecord('21df2686', component.options)
    } else {
      api.reload('21df2686', component.options)
    }
    module.hot.accept("./manualsmg5.vue?vue&type=template&id=21df2686&scoped=true&", function () {
      api.rerender('21df2686', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/social/manualsmg5.vue"
export default component.exports